// extracted by mini-css-extract-plugin
export default {"range":"_range_aTpqyP","labels":"_labels_5UTlzd","min":"_min_FxoFKi","max":"_max_LSy3Tl"};